<script>
import mixinComponent from '../../Mixins/mixinComponent'
import { globalVariablesMixin } from '../../Mixins/global'
import CommissionFormModal from './CommissionFormModal.vue'

export default {
  components: { CommissionFormModal },
  mixins: [mixinComponent, globalVariablesMixin],

  props: {
    financeId: { type: Number, required: true },
    commissions: { type: Object, default: [], required: true },
    idModalPage: { type: String, default: '' },
  },

  data() {
    return {
      fields: [],
    }
  },

  methods: {
    commissionSent(e) {
      let commissionIndex = this.commissions.findIndex((eq) => eq.id === e.json.id)
      if (e.method != 'delete') {
        if (commissionIndex == -1) {
          this.commissions.push(e.json)
        } else {
          this.commissions.splice(commissionIndex, 1, e.json)
        }
      } else {
        this.commissions.splice(commissionIndex, 1)
      }
      this.$emit('commissions-sent', this.commissions)
    },
  },
}
</script>
<template>
  <div class="commission-list">
    <div class="table-responsive-sm">
      <table v-if="commissions.length > 0" class="table table-striped table-hover fs-16">
        <thead>
          <tr>
            <th>{{ $t('commission.list.entity') }}</th>
            <th>{{ $t('commission.list.amount') }}</th>
            <th>{{ $t('commission.list.percent') }}</th>
            <th>{{ $t('commission.list.gift') }}</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(commission, index) in commissions" :e2e-row="'commission-' + index">
            <td e2e-data="commissionEntityName">{{ commission.entity ? commission.entity.name : '' }}</td>
            <td e2e-data="commissionAmount">{{ $n(Number(commission.amount), 'currency') }}</td>
            <td e2e-data="commissionPercent">{{ commission.percent }}</td>
            <td>
              <div class="d-flex flex-column">
                <span v-if="commission.gift" e2e-data="commissionGift">
                  {{
                    $t('commission.list.giftEntity') + ' : ' + (commission.giftEntity ? commission.giftEntity.name : '')
                  }}
                </span>
                <span v-if="commission.salesman" e2e-data="commissionSalesman">
                  {{ $t('commission.list.salesman') + ' : ' + commission.salesman }}
                </span>
              </div>
            </td>
            <td v-if="!user.isReadOnly" style="display: flex; justify-content: space-evenly">
              <CommissionFormModal
                :ref="commission.id"
                :finance-id="financeId"
                :commission-id="commission.id"
                :method="'patch'"
                @commissions-sent="commissionSent"
              />
              <CommissionFormModal
                :finance-id="financeId"
                :commission-id="commission.id"
                :method="'delete'"
                @commissions-sent="commissionSent"
              />
            </td>
          </tr>
        </tbody>
      </table>
      <CommissionFormModal
        v-if="!user.isReadOnly"
        ref="commissionForm"
        :id-modal-page="idModalPage"
        :finance-id="financeId"
        :method="'post'"
        @commissions-sent="commissionSent"
      />
    </div>
  </div>
</template>
